import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareInboxNextGenRoute: InvariantJiraRoute = {
	name: 'inbox',
	path: '/jira/software/projects/:projectKey/inbox/:issueKey?',
};
